// extracted by mini-css-extract-plugin
export default {"main":"NewsFormModal_main__6kKMq","preview":"NewsFormModal_preview__S07Ft"};